module.exports = __webpack_public_path__ + "img/close.03e6b535.svg";